module.exports = __webpack_public_path__ + "img/add_car_zh.47920408.png";